package com.sweetlime.dungeonamigo.model

import com.sweetlime.dungeonamigo.util.LongAsDoubleSerializer
import kotlinx.serialization.Serializable

@Serializable
data class Character(
    val id: String = "",
    val userId: String = "",
    val name: String = "",
    val race: String = "",
    val subrace: String = "",
    val characterClass: String = "",
    val subclass: String = "",
    val level: Int = 1,
    val background: String = "",
    val alignment: String = "",
    val experiencePoints: Int = 0,

    val strength: Int = 10,
    val dexterity: Int = 10,
    val constitution: Int = 10,
    val intelligence: Int = 10,
    val wisdom: Int = 10,
    val charisma: Int = 10,

    val maxHp: Int = 0,
    val currentHp: Int = 0,
    val temporaryHp: Int = 0,

    val armorClass: Int = 10,
    val initiative: Int = 0,
    val speed: Int = 30,
    val hitDice: String = "",
    val hitDiceRemaining: Int = 1,

    val savingThrowProficiencies: List<String> = emptyList(),
    val skillProficiencies: List<String> = emptyList(),
    val expertiseSkills: List<String> = emptyList(),

    val spellSlots: Map<String, SpellSlotLevel> = emptyMap(),
    val conditions: List<String> = emptyList(),

    val inventory: List<InventoryItem> = emptyList(),
    val personalityTraits: String = "",
    val ideals: String = "",
    val bonds: String = "",
    val flaws: String = "",
    val backstory: String = "",
    val notes: String = "",

    val knownSpells: List<String> = emptyList(),
    val preparedSpells: List<String> = emptyList(),

    val avatarId: String = "",

    @Serializable(with = LongAsDoubleSerializer::class)
    val portraitPrimaryColor: Long = 0xFFD4A843L,
    @Serializable(with = LongAsDoubleSerializer::class)
    val portraitSecondaryColor: Long = 0xFF4A90D9L,

    @Serializable(with = LongAsDoubleSerializer::class)
    val createdAt: Long = 0,
    @Serializable(with = LongAsDoubleSerializer::class)
    val updatedAt: Long = 0,
)

@Serializable
data class SpellSlotLevel(val total: Int = 0, val used: Int = 0)

@Serializable
data class InventoryItem(
    val id: String = "",
    val name: String = "",
    val quantity: Int = 1,
    val weight: Double = 0.0,
    val description: String = "",
    val equipped: Boolean = false,
)